import { useGetPatient, useRecordPatientView } from '@/modules/patients/api'
import { useGetPatientHistory } from '@/modules/patients/api/use-get-patient-history'
import { EventLog, Patient } from '@cypro/engine/schema'
import { createContext, PropsWithChildren, useContext, useMemo } from 'react'

interface State {
  patient: Patient
  history?: EventLog[] | undefined
}

interface Props extends State, PropsWithChildren {}

const PatientContext = createContext<State>({} as State)

export function PatientProvider({children, patient: initialPatient}: Props) {
  const [history] = useGetPatientHistory(initialPatient?.id)
  const [patient] = useGetPatient(initialPatient.id)
  useRecordPatientView(initialPatient?.id)

  const value = useMemo(() => ({patient, history}), [patient, history])

  return <PatientContext.Provider value={value}>{children}</PatientContext.Provider>
}

export function usePatientContext() {
  return useContext(PatientContext)
}
